import pushEvent, {
  EVENT_CATALOG_TOGGLE_FILTER,
  EVENT_CATALOG_SHOW_MORE_FILTER,
  EVENT_CATALOG_PRICE_FILTER,
  EVENT_FILTER_CLEAR,
} from 'pushEvent';

import {
  SET_TOOGLE_FILTER_STATE,
  SET_UPDATE_FILTER_ACTIVE_OPTION,
  SET_FILTER_SHOW_ALL_OPTIONS,
  SET_FILTER_RANGE_VALUES,
  FILTER_SLUG_PRICE,
  DISABLE_FILTERS,
} from './constants';
import {
  getFilterActiveOptions,
  getAllFiltersActiveOptions,
  getFilterOptionsCount,
  getCurrentFilterSectionName,
  currentFilterChoiceName,
  getFilterRangeUsed,
  selectAllFiltersForAnalytics,
} from './selectors';
import { updateCatalogProductsDelicately, setFiltersBarChange, forceRemainsOnly } from '../actions';
import { getCatalogFiltersBarChangedState, getCatalogDisableFilters } from '../controls/selectors';

export const setToggleFilter =
  (slug, isOpen) =>
  // isOpen state will be reverted - !isOpen in reducer, due to toggle logic
  (dispatch) => {
    dispatch({
      type: SET_TOOGLE_FILTER_STATE,
      slug,
      isOpen,
    });
  };

export const toggleFilterOption =
  ({ filterSlug, optionSlug }) =>
  (dispatch, getState) => {
    const state = getState();
    const filtersAreChanged = getCatalogFiltersBarChangedState(state);

    const activeOptions = getFilterActiveOptions(state, filterSlug);
    // ===

    dispatch({
      type: SET_UPDATE_FILTER_ACTIVE_OPTION,
      filterSlug,
      optionSlug,
      payload: activeOptions.indexOf(optionSlug) === -1,
    });

    // ===
    if (!filtersAreChanged) {
      dispatch(setFiltersBarChange(true));
    }
    dispatch(updateCatalogProductsDelicately());

    // toggle filter GTM push
    const currentFilterSection = getCurrentFilterSectionName(state)(filterSlug);
    const currentFilterChoice = currentFilterChoiceName(state)(filterSlug, optionSlug);

    pushEvent(EVENT_CATALOG_TOGGLE_FILTER, {
      section: currentFilterSection,
      choice: currentFilterChoice,
      isActive: filtersAreChanged,
    });
  };

export const setShowAllOptions = (slug) => (dispatch, getState) => {
  const state = getState();
  // we create new array on every change, if active add new slug, if not - splice it
  const allOptionsCount = getFilterOptionsCount(state, slug);
  // ===
  dispatch({
    type: SET_FILTER_SHOW_ALL_OPTIONS,
    slug,
    count: allOptionsCount,
  });

  // push event to GTM
  const currentFilterSection = getCurrentFilterSectionName(state)(slug);
  pushEvent(EVENT_CATALOG_SHOW_MORE_FILTER, {
    section: currentFilterSection,
  });
};

export const setRangeFilterValues =
  ({ valueFrom, valueTo }) =>
  (dispatch, getState) => {
    const state = getState();
    // push event to GTM
    const rangeUsed = getFilterRangeUsed(state);
    if (!rangeUsed) {
      pushEvent(EVENT_CATALOG_PRICE_FILTER);
    }
    dispatch({
      type: SET_FILTER_RANGE_VALUES,
      slug: FILTER_SLUG_PRICE,
      ...(typeof valueFrom !== 'undefined' ? { valueFrom } : {}),
      ...(typeof valueTo !== 'undefined' ? { valueTo } : {}),
      used: true,
    });
    dispatch(updateCatalogProductsDelicately());
  };

export const resetAllOptions = () => (dispatch, getState) => {
  const state = getState();
  // ===
  const allActiveOptions = getAllFiltersActiveOptions(state);
  const disableFilters = getCatalogDisableFilters(state);

  allActiveOptions.forEach((activeFilter) => {
    const { slug, activeOptions } = activeFilter;
    if (activeOptions.length !== 0) {
      activeOptions.forEach((optionSlug) =>
        dispatch({
          type: SET_UPDATE_FILTER_ACTIVE_OPTION,
          filterSlug: slug,
          optionSlug,
          payload: false,
        }),
      );
    }
  });
  // ===
  dispatch({
    type: SET_FILTER_RANGE_VALUES,
    slug: FILTER_SLUG_PRICE,
    valueFrom: null,
    valueTo: null,
  });
  const filtersDataAnalytics = selectAllFiltersForAnalytics(getState());
  pushEvent(EVENT_FILTER_CLEAR, {
    title: filtersDataAnalytics.title,
    items: filtersDataAnalytics.totalFoundItems,
    filters: filtersDataAnalytics.filters,
  });

  if (disableFilters) {
    dispatch(enableFilters());
    dispatch(forceRemainsOnly(true));
  }
  // ===
  dispatch(updateCatalogProductsDelicately());
};

export const enableFilters = () => ({
  type: DISABLE_FILTERS,
  disableFilters: false,
});
